/**
 * ハウスマニュアル関連のStoreで使用するStateをここで定義する
 *
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Record } from 'immutable'

const _HouseManualState = {
  id: null,
  title: '',
  title_ja: '',
  title_en: '',
  title_zh: '',
  title_ko: '',
  keywords: '',
  keywords_ja: '',
  keywords_en: '',
  keywords_zh: '',
  keywords_ko: '',
  manual: null,
  manual_name: '',
  manual_url: '',
  position: null
}

class HouseManualState extends Record(_HouseManualState) {
  mergeModel(model) {
    const title = JSON.parse(model.title)
    const keywords = JSON.parse(model.keywords)

    model.title = title || {}
    model.title_ja = title.ja || ''
    model.title_en = title.en || ''
    model.title_zh = title.zh || ''
    model.title_ko = title.ko || ''

    model.keywords = keywords || {}
    model.keywords_ja = keywords.ja || ''
    model.keywords_en = keywords.en || ''
    model.keywords_zh = keywords.zh || ''
    model.keywords_ko = keywords.ko || ''

    model.manual_url = model.manual_url || ''
    model.manual = model.manual_url
    const manual_name = model.manual_url
    model.manual_name = manual_name ? manual_name.replace(/.*\/|[^.]*\/$/g, '') : ''

    return this.merge(model)
  }

  setTitle() {
    const title = {
      ja: this.title_ja || '',
      en: this.title_en || '',
      zh: this.title_zh || '',
      ko: this.title_ko || ''
    }

    return this.merge({ title: title })
  }

  setKeywords() {
    const keywords = {
      ja: this.keywords_ja || '',
      en: this.keywords_en || '',
      zh: this.keywords_zh || '',
      ko: this.keywords_ko || ''
    }

    return this.merge({ keywords: keywords })
  }
}

export { HouseManualState }
